import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAddressesByUserId } from "../redux/reducer/userAddressReducer";

export const useLanguageNavigate = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { lang } = useParams();
  const addresses = useSelector((state) => state.userAddress);

  const fetchid =
    (() => {
      const accessToken = localStorage.getItem("accessToken");

      if (accessToken && !addresses?.user) {
        dispatch(getAddressesByUserId());
      }
    },
    []);

  useEffect(() => {
    const accessToken = localStorage.getItem("accessToken");

    if (accessToken && addresses?.user?.language) {
      fetchid();
      const userLang = addresses.user.language;
      localStorage.setItem("language", userLang);
    }
  }, [addresses]);

  const navigateWithLang = (path, options = {}) => {
    const accessToken = localStorage.getItem("accessToken");

    let currentLang;
    if (accessToken && addresses?.user?.language) {
      currentLang = addresses.user.language;
    } else {
      currentLang = lang || localStorage.getItem("language") || "ar";
    }

    localStorage.setItem("language", currentLang);

    // const currentQuery = window.location.search; // ?token=...
    // const pathWithLang = `/${currentLang}${path}${currentQuery}`;
    const pathWithLang = `/${currentLang}${path}`;

    navigate(pathWithLang, options);
  };

  return navigateWithLang;
};
